import { styled, Tooltip } from '@mui/material';
import Colours from '../../Theme/Colours';

export const StyledTooltip = styled(Tooltip)({
  '&.MuiTooltip-tooltip	': {
    padding: '7px 6px',
    margin: '6px 0',
    backgroundColor: Colours.Backgrounds.tooltip,
  },
})